import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import './dropdown.scss';
import Link from "./Link";
import Column from "./Column";
import { createTargetId } from '../../utils/util_functions.js';
export default function Dropdown(props) {

  const elementRef = useRef(null);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [elementRef]);

  const toggle = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(!isOpen);
  };

  const close = (e) => {
    e.stopPropagation();
    setOpen(false);
  };

  return (
    <div ref={elementRef}
         className={`aps__dropdown align-${props.align} ${isOpen ? 'is-open' : ''}`}>
      <Link 
          testid={`header-nav-dropdown-toggle-link-${createTargetId(props.title)}`}
          externalTarget={`header-nav-dropdown-toggle-link-${createTargetId(props.title)}`}
          key={`toggle`}
          className={`aps__link ${props.classes}`}
          target={props.target ? props.target : ''}
          action={toggle}
        >
        {props.open
          ? props.open
          : props.title
        }
      </Link>
      <div className={`aps__dropdown-links`}>
        <div className={`aps__link aps__dropdown-back`} onClick={close}>Back</div>
        {props.title.length > 0 &&
          <label className={`aps__dropdown-title`}>
            {props.title}
          </label>
        }
        {props.children}
        {props.links.map((item) => {
          if (item.options?.attributes?.column && item.below) {
            return (
              <Column key={item.key}
                      links={item.below}
                      classes={item.options?.attributes?.class ? item.options.attributes.class.join(' ') : ''}
                      grid={item.options?.attributes?.column == 'column_with_grid'}>
                {item.options.attributes.column == 'column_with_title' &&
                  <label>{item.title}</label>
                }
              </Column>
            );
          } else {
            return (
              <Link 
                    testid={`header-nav-dropdown-toggle-link-${createTargetId(item.title)}`}
                    externalTarget={`header-nav-dropdown-toggle-link-${createTargetId(item.title)}`}
                    key={item.key}
                    link={item.absolute}
                    target={item.options?.attributes?.target ? item.options.attributes.target : ''}
                    classes={item.options?.attributes?.class ? item.options.attributes.class.join(' ') : ''}>
                {item.title}
              </Link>
            );
          }
        })}
      </div>
    </div>
  );
}
;

Dropdown.propTypes = {
  links: PropTypes.array,
  classes: PropTypes.string,
  title: PropTypes.string,
  align: PropTypes.string,
  grid: PropTypes.number,
  open: PropTypes.array,
  children: PropTypes.node,
};

Dropdown.defaultProps = {
  links: [],
  classes: '',
  title: '',
  align: 'left',
};
